import { CommodityMilestone, CommodityMilestoneActivity, MilestoneStatusCode } from '@bechtel/types';

export interface MilestoneListProps {
  hidden: boolean;
  milestones: CommodityMilestone[];
  activityHistory: CommodityMilestoneActivity[];
}

export interface MilestoneProps {
  milestone: CommodityMilestone;
  hidden: boolean;
  isUserClaimer: boolean;
}

export enum MilestoneStatusExtended {
  BLOCKED = 'BLOCKED',
}

export type MilestoneStatusExt = MilestoneStatusCode | MilestoneStatusExtended;

export interface MilestoneStylingProps {
  status: MilestoneStatusExt;
}

export interface MilestoneCardStyledProps {
  status: MilestoneStatusExt;
}

export interface MilestoneBodyStyledProps {
  isFullCardLinkRequired: boolean;
}
